import { IconoAlerta } from "../../AuditoriaClinica/rediseno/AuditIconos";

// REDISENO-SMARTMEDIC · FASE 3 -- piezas de celda del DataTable.
// Están aparte del componente para que cualquier pantalla las use al declarar
// sus columnas sin arrastrar la tabla entera.

const vacio = (texto = "—") => <span className="dt__vacio">{texto}</span>;

/**
 * Dos datos que se leen juntos en UNA celda: el principal arriba y el
 * secundario debajo. Es la regla que quita tres columnas de la tabla sin
 * perder un solo dato (Nº de cita + fecha, paciente + documento,
 * aseguradora + plan).
 */
export function CeldaDoble({ principal, secundario, monoPrincipal, monoSecundario }) {
    const hayPrincipal = principal !== null && principal !== undefined && principal !== "";
    const haySecundario = secundario !== null && secundario !== undefined && secundario !== "";
    return (
        <div className="dt-doble">
            <span
                className={`dt-doble__principal${monoPrincipal ? " dt-doble__secundario--mono" : ""}`}
                title={hayPrincipal ? String(principal) : undefined}
            >
                {hayPrincipal ? principal : vacio()}
            </span>
            <span
                className={`dt-doble__secundario${monoSecundario ? " dt-doble__secundario--mono" : ""}`}
                title={haySecundario ? String(secundario) : undefined}
            >
                {haySecundario ? secundario : vacio()}
            </span>
        </div>
    );
}

/** Valor simple con truncado y `title`; em dash tenue si no hay dato. */
export function Celda({ valor, mono }) {
    const hay = valor !== null && valor !== undefined && valor !== "";
    if (!hay) return vacio();
    return (
        <span className={mono ? "dt__td--mono" : undefined} title={String(valor)}>
            {valor}
        </span>
    );
}

export const TONOS_CHIP = ["neutro", "progreso", "exito", "peligro", "info", "alerta"];

/**
 * Pastilla de estado con punto de color. `alerta` añade además un icono: un
 * dato incompleto se SEÑALA, no se disfraza de valor normal.
 *
 * `icono` permite sustituir el punto cuando el estado tiene un símbolo propio
 * más elocuente que un color -- el check de "Sincronizado con Contífico", por
 * ejemplo. Es OPCIONAL y no cambia el aspecto de ningún chip existente: sin
 * él, el punto y el icono de `alerta` siguen exactamente igual.
 */
export function ChipEstado({ tono = "neutro", children, title, icono: Icono }) {
    const seguro = TONOS_CHIP.includes(tono) ? tono : "neutro";
    const marca = Icono ? (
        <Icono size={13} />
    ) : seguro === "alerta" ? (
        <IconoAlerta size={13} />
    ) : (
        <span className="dt-chip__punto" aria-hidden="true" />
    );
    return (
        <span className={`dt-chip dt-chip--${seguro}`} title={title} data-tono={seguro}>
            {marca}
            {children}
        </span>
    );
}

/**
 * Nombres en Title Case: `VELA CEDEÑO KENLLY LEONELA` obliga a leer letra por
 * letra. Se respetan las partículas y las iniciales de una sola letra.
 */
const PARTICULAS = new Set(["de", "del", "la", "las", "los", "y", "da", "do", "van", "von"]);
export function tituloDeNombre(valor) {
    if (typeof valor !== "string" || valor.trim() === "") return valor;
    return valor
        .toLocaleLowerCase("es")
        .split(/\s+/)
        .map((palabra, i) => {
            if (i > 0 && PARTICULAS.has(palabra)) return palabra;
            return palabra.charAt(0).toLocaleUpperCase("es") + palabra.slice(1);
        })
        .join(" ");
}

/**
 * Regla "si un filtro fija un valor único, la columna desaparece".
 * Se declara en la columna (`fijadaPor: "estado_cita"`) y se resuelve con los
 * filtros aplicados: explícito y comprobable, nunca adivinando desde los datos.
 */
export function columnasVisibles(columnas, filtros = {}) {
    return (columnas || []).filter((col) => {
        if (!col.fijadaPor) return true;
        const valor = filtros[col.fijadaPor];
        return valor === undefined || valor === null || valor === "";
    });
}
